import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "labelPlacement", "labelClickable"];
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useRef } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { EmbersLabeledBox } from '../labeledBox/labeledBox';
import { EmbersBaseSwitch } from './baseSwitch';
import classnames from 'classnames';
import { createSwitchTheme, ROOT_PREFIX } from './switchStyles';
export var EmbersSwitch = function EmbersSwitch(_ref) {
  var label = _ref.label,
    _ref$labelPlacement = _ref.labelPlacement,
    labelPlacement = _ref$labelPlacement === void 0 ? 'end' : _ref$labelPlacement,
    _ref$labelClickable = _ref.labelClickable,
    labelClickable = _ref$labelClickable === void 0 ? true : _ref$labelClickable,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var switchTheme = createSwitchTheme();
  var toggleRef = useRef(null);
  var onChange = function onChange(event, checked) {
    var _otherProps$onChange;
    (_otherProps$onChange = otherProps.onChange) === null || _otherProps$onChange === void 0 || _otherProps$onChange.call(otherProps, event, checked);
  };
  var toggle = /*#__PURE__*/React.createElement(EmbersBaseSwitch, _extends({
    ref: toggleRef,
    className: classnames(_defineProperty({}, "".concat(ROOT_PREFIX, "-start"), labelPlacement === 'start')),
    onChange: onChange
  }, otherProps));
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: switchTheme
  }, /*#__PURE__*/React.createElement(EmbersLabeledBox, {
    label: label || '',
    labelClickable: labelClickable,
    formControlProps: {
      control: toggle,
      label: label || '',
      labelPlacement: labelPlacement
    }
  }, toggle));
};